import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalsService } from './globals';

@Injectable({
  providedIn: 'root',
})
export class PdaService {
  url: string = this.globals.apiUrl;
  constructor(private http: HttpClient, private globals: GlobalsService) {}
  private header(): HttpHeaders {
    return new HttpHeaders({
      Authorization: 'Bearer ' + this.globals.user.token,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    });
  }
  public getActivePlans() {
    return this.http.get(this.url + '/api/plan-pda/list', {
      headers: this.header(),
    });
  }
  public getSelectedPlan(planId) {
    return this.http.get(this.url + `/api/plan-pda/${planId}`, {
      headers: this.header(),
    });
  }
  public sendToHistoric(body) {
    return this.http.put(this.url + '/api/plan-pda/historico', body, {
      headers: this.header(),
    });
  }
  public getHistoricList() {
    return this.http.get(this.url + '/api/plan-pda/historico', {
      headers: this.header(),
    });
  }
  public sendToActives(body) {
    return this.http.put(
      this.url + '/api/plan-pda/historico-reestablecer',
      body,
      {
        headers: this.header(),
      }
    );
  }
  public deleteHistoric(planId: number | string) {
    return this.http.delete(this.url + `/api/plan-pda/${planId}`, {
      headers: this.header(),
    });
  }
  public createPlan(body, id = null) {
    if (id) {
      return this.http.put(this.url + `/api/plan-pda/${id}`, body, {
        headers: this.header(),
      });
    } else {
      return this.http.post(this.url + '/api/plan-pda', body, {
        headers: this.header(),
      });
    }
  }
  public createAction(planId, body, actionId = null) {
    if (actionId) {
      return this.http.put(
        this.url + `/api/plan-pda/${planId}/accion/${actionId}`,
        body,
        {
          headers: this.header(),
        }
      );
    } else {
      return this.http.post(this.url + `/api/plan-pda/${planId}/accion`, body, {
        headers: this.header(),
      });
    }
  }
  public editAction(planId, body, actionId) {
    return this.http.put(
      this.url + `/api/plan-pda/${planId}/accion/${actionId}`,
      body,
      {
        headers: this.header(),
      }
    );
  }
  public deleteAction(planId, accionId) {
    return this.http.delete(
      this.url + `/api/plan-pda/${planId}/accion/${accionId}`,
      {
        headers: this.header(),
      }
    );
  }
  public deleteSelected(body, planId) {
    return this.http.post(
      this.url + `/api/plan-pda/${planId}/accion/delete_masive `,
      body,
      {
        headers: this.header(),
      }
    );
  }
  public actionOrder(body, plan_id) {
    return this.http.post(
      this.url + `/api/plan-pda/${plan_id}/accion/orden `,
      body,
      {
        headers: this.header(),
      }
    );
  }
  public getPlanAction(planId) {
    return this.http.get(this.url + `/api/plan-pda/${planId}/accion`, {
      headers: this.header(),
    });
  }
  public getSingleAction(planId,actionId) {
    return this.http.get(this.url + `/api/plan-pda/${planId}/accion/${actionId}`, {
      headers: this.header(),
    });
  }
  public getStatistics(planId) {
    return this.http.get(this.url + `/api/plan-pda/${planId}/estadistica`, {
      headers: this.header(),
    });
  }
  public getStatisticsSummary(planId) {
    return this.http.get(
      this.url + `/api/plan-pda/${planId}/estadistica-resumen`,
      {
        headers: this.header(),
      }
    );
  }
  public getSummary(planId) {
    return this.http.get(this.url + `/api/plan-pda/${planId}/resumen`, {
      headers: this.header(),
    });
  }
  public getReport(planId) {
    return this.http.get(
      this.url + `/api/reporte/toolbox/1/plan-pda/${planId}/informe`,
      {
        headers: this.header(),

        responseType: 'blob',
      }
    );
  }
  public getHistoricActionList(planId) {
    return this.http.get(
      this.url + `/api/plan-pda/${planId}/accion/historico`,
      {
        headers: this.header(),
      }
    );
  }
  public sendActionToHistoric(planId, body) {
    return this.http.put(
      this.url + `/api/plan-pda/${planId}/accion/historico`,
      body,
      {
        headers: this.header(),
      }
    );
  }
  public reactivateActions(planId, body) {
    return this.http.put(
      this.url + `/api/plan-pda/${planId}/accion/historico-reestablecer`,
      body,
      {
        headers: this.header(),
      }
    );
  }
  public sangrias(body, plan_id) {
    return this.http.post(
      this.url + `/api/plan-pda/${plan_id}/accion/sangria `,
      body,
      {
        headers: this.header(),
      }
    );
  }
  public getGrupos() {
    return this.http.get(this.url + '/api/grupo', {
      headers: this.header(),
    });
  }
  public addMembers(body, plan_id) {
    return this.http.post(
      this.url + `/api/plan-pda/${plan_id}/integrante `,
      body,
      {
        headers: this.header(),
      }
    );
  }
}
